import React, { useState } from "react";
import {
	Nav,
	NavItem,
	NavLink,
	TabContent,
	TabPane,
	Button,
	Card,
	CardBody,
} from "reactstrap";
import classnames from "classnames";
import TecAssuredDynamicForm from "./TecAssuredDynamicForm";
import TecAssuredQuotes from "./TecAssuredQuotes";
import TecAssuredDynamicProductProperties from "./TecAssuredDynamicProductProperties";
import TecAssuredFinalizeTab from "./TecAssuredFinalizeTab";

const TecAssuredWizard = () => {
	const [activeTab, setActiveTab] = useState("1");

	const goToNextTab = () => {
		if (activeTab === "1") setActiveTab("2");
		if (activeTab === "2") setActiveTab("3");
		if (activeTab === "3") setActiveTab("4");
		// Add more tabs as needed
	};

	const goToPrevTab = () => {
		setActiveTab("1");
	};

	return (
		<Card>
			<Nav tabs>
				<NavItem>
					<NavLink
						className={classnames({
							active: activeTab === "1",
							disabled: true,
						})}
						onClick={(e) => e.preventDefault()} // Disable tab clicks
					>
						Vehicle Info
					</NavLink>
				</NavItem>
				<NavItem>
					<NavLink
						className={classnames({
							active: activeTab === "2",
							disabled: true,
						})}
						onClick={(e) => e.preventDefault()}
					>
						Quotes
					</NavLink>
				</NavItem>
				<NavItem>
					<NavLink
						className={classnames({
							active: activeTab === "3",
							disabled: true,
						})}
						onClick={(e) => e.preventDefault()}
					>
						Product Properties
					</NavLink>
				</NavItem>
				<NavItem>
					<NavLink
						className={classnames({
							active: activeTab === "4",
							disabled: true,
						})}
						onClick={(e) => e.preventDefault()}
					>
						Finalize
					</NavLink>
				</NavItem>
			</Nav>

			<TabContent activeTab={activeTab}>
				<TabPane tabId="1">
					<CardBody>
						<TecAssuredDynamicForm onComplete={goToNextTab} />
					</CardBody>
				</TabPane>

				<TabPane tabId="2">
					<CardBody>
						<TecAssuredQuotes onComplete={goToNextTab} />
						<Button onClick={goToPrevTab}>Start over</Button>
					</CardBody>
				</TabPane>

				<TabPane tabId="3">
					<CardBody>
						<TecAssuredDynamicProductProperties onComplete={goToNextTab} />
						<Button onClick={goToPrevTab}>Start over</Button>
					</CardBody>
				</TabPane>

				<TabPane tabId="4">
					<CardBody>
						<TecAssuredFinalizeTab onComplete={goToNextTab} />
						<Button onClick={goToPrevTab}>Start over</Button>
					</CardBody>
				</TabPane>
			</TabContent>
		</Card>
	);
};

export default TecAssuredWizard;
